import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router';
import { 
  FaInstagram,
  FaFacebookF, 
  FaWhatsapp,
  FaTimes,
  FaChevronDown,
  FaChevronUp 
} from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { GiHamburgerMenu } from 'react-icons/gi';
import './head.css';
import logo from '../../images/logo.png';
import { projects } from '../../assets/projects';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const menuRef = useRef();

// Get unique locations
const locations = [...new Set(projects.map(product => product.location))];
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 760);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
        setIsSticky(window.scrollY > 124);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
}, []);


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 200);
    };

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const closeAll = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };
  const MobileDropdown = ({ name, title, items }) => (
    <div className="mobile-dropdown">
      <button onClick={() => toggleDropdown(name)}>
        {title}
        {openDropdown === name ? <FaChevronUp /> : <FaChevronDown />}
      </button>
      {openDropdown === name && (
        <div className="mobile-dropdown-content">
          {items.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              onClick={closeAll}
              className={({ isActive }) => 
                `dropdown-item ${isActive ? 'active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <header className="header-container">
      {/* Top Row - Hidden on scroll */}
      <div className={`top-row ${isScrolled ? 'hidden' : ''}`}>
        <div className="cantact-location"><span className='location-label'>Call Us:</span> +254 768 999 333</div>
        <div className="cta-area"> <span className="typewriter">🚀 Enjoy discounts of up to 10% with our Cash Offers!. <NavLink to=''>Learn more...</NavLink></span></div>
        <div className="social-icons">
          <NavLink to ="https://www.instagram.com/zuri_land_investments?igsh=cThqcDNwaDkwMzkw"><FaInstagram className="social-icon" aria-label="Instagram" /></NavLink>
          <NavLink to =""><FaXTwitter className="social-icon" aria-label="X Twitter" /></NavLink>
          <NavLink to ="https://www.facebook.com/ZuriLandInvestments"><FaFacebookF className="social-icon" aria-label="Facebook" /></NavLink>
          <NavLink to ="https://wa.link/sqpagj"><FaWhatsapp className="social-icon" aria-label="WhatsApp" /></NavLink>
        </div>
      </div>

      {/* Bottom Row - Permanent Sticky */}
      <div className={`bottom-row ${isSticky ? 'sticky' : ''}`} ref={menuRef}  >
        <div className="bottom-content">

        <NavLink to="/" className="logo"><img src={logo} alt='logo' className='logo-img' /></NavLink>
        
        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <NavLink 
            to="/" 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            Home
          </NavLink>
          
          <div className="dropdown">
            <span className="dropdown-trigger">Our Projects ▾</span>
            <div className="dropdown-content">
              {
              locations.map(location => (
                <>
                <NavLink 
                to = {`/locations/${encodeURIComponent(location).replace(/%20/g, '-')}`}
                className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`}
              >
                {'Plots in ' + location}
              </NavLink>
              </>
              ))}
            </div>
          </div>

          <NavLink 
            to="/AboutUs" 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            About Us
          </NavLink>

          <div className="dropdown">
            <span className="dropdown-trigger">Resources ▾</span>
            <div className="dropdown-content">
              <NavLink 
                to="/blog" 
                className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`}
              >
                Blog
              </NavLink>
              <NavLink 
                to="/docs" 
                className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`}
              >
                Downloads
              </NavLink>
              <NavLink 
                to="/faq" 
                className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`}
              >
                FAQ
              </NavLink>
            </div>
          </div>

          <NavLink 
            to="/contact" 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            Contact
          </NavLink>

          <NavLink 
            to="/Diaspora" 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            Diaspora
          </NavLink>
          
          <NavLink 
            to="/Media" 
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            Media
          </NavLink>
        </nav>

        {/* Mobile Navigation */}
        {isMobile && (
          <>
            <button 
              className="hamburger" 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? <FaTimes /> : <GiHamburgerMenu />}
            </button>
            
            <div className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
              <NavLink to="/" onClick={closeAll}>Home</NavLink>
              
              <MobileDropdown
                name="products"
                title="Products"
                items = {locations.map(location =>({
                  path: `/locations/${encodeURIComponent(location).replace(/%20/g, '-')}`, label :'Plots in ' + location
                }))}
              />

              <NavLink to="/AboutUs" onClick={closeAll}>About Us</NavLink>

              <MobileDropdown
                name="resources"
                title="Resources"
                items={[
                  { path: "/blog", label: "Blog" },
                  { path: "/docs", label: "Documentation" },
                  { path: "/faq", label: "FAQ" }
                ]}
              />

              <NavLink to="/contact" onClick={closeAll}>Contact Us</NavLink>
              <NavLink to="/Diaspora" onClick={closeAll}>Diaspora</NavLink>
              <NavLink to="/Media" onClick={closeAll}>Media</NavLink>
            </div>
          </>
        )}
        </div>
      </div>
    </header>
  );
};

export default Header;